import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 mb-4">
            <i className="ri-vidicon-line text-accent-600 text-sm"></i>
            <span className="text-accent-700 text-xs font-medium">吃瓜现场</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            吃瓜现场
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            视频深扒，用镜头还原事件背后的真实故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-950/20" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/80 flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-1 rounded bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">{item.views} 次播放</span>
              </div>
            </div>
          ))}

          {/* 后两项横向铺满 */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {mediaItems.slice(3).map((item) => (
              <div
                key={item.id}
                className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="flex flex-col sm:flex-row">
                  <div className="sm:w-56 h-40 sm:h-auto relative overflow-hidden flex-shrink-0">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-10 h-10 rounded-full bg-primary-500/80 flex items-center justify-center transition-transform group-hover:scale-110">
                        <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                      </div>
                    </div>
                    <div className="absolute bottom-2 right-2">
                      <span className="px-2 py-0.5 rounded bg-background-950/60 backdrop-blur-sm text-background-50 text-xs">
                        {item.duration}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 p-4 flex flex-col justify-between">
                    <div>
                      <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </h3>
                    </div>
                    <span className="text-xs text-foreground-400">{item.views} 次播放</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}